import React from 'react'
import { useReturnCurrentUser } from '../user/userSlice'
import Statistics from './Statistics'
import ItemsBasePage from '../items/ItemsBasePage'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import TransactionsList from '../transactions/TransactionsList'
import IssuesList from '../issues/IssuesList'
import LatestUpdate from '../updates/LatestUpdate'
import DocumentationLink from './DocumentationLink'

export default function DashboardBasePage() {

    const user = useReturnCurrentUser()

    /**
     * Return greeting message
     */
    const returnGreetingMessage = () => {

        const time = new Date().getHours()

        let message: string = "Hello"

        if (time >= 3){
            message = "Good morning"
        }

        if (time >= 12 ){
            message = "Good afternoon"
        }

        if (time >= 18){
            message = "Good evening"
        }

        return message + ", " + user.first_name + "!"

    }

    return(
        <div className="dashboard-admin-page-container">

            <div className="admin-base-page-head-section-container">
                <div className="content-of-admin-base-page-head-section-container">

                    <div className="text-box-of-admin-base-page-head-section-container">
                        <div className="content-of-text-box-of-admin-base-page-head-section-container">
                            <h2>{returnGreetingMessage()}</h2>
                        </div>
                    </div>

                </div>
            </div>

            <div className="stats-box-of-dashboard-admin-page-container">
                <Statistics />
            </div>

            <DocumentationLink />

            <LatestUpdate />

            {/* <div className="items-of-dashboard-admin-page-container dashboard-page-section-container data-displayer-section-box-style">
                <SectionBoxContainer showTitle title="Items">
                    <ItemsBasePage dashboardPage />
                </SectionBoxContainer>
            </div>

            <div className="items-of-dashboard-admin-page-container dashboard-page-section-container data-displayer-section-box-style">
                <SectionBoxContainer showTitle title="Transactions">
                    <TransactionsList hidePageHeadSection />
                </SectionBoxContainer>
            </div>

            <div className="items-of-dashboard-admin-page-container dashboard-page-section-container data-displayer-section-box-style">
                <SectionBoxContainer showTitle title="Issues">
                    <IssuesList hidePageHeadSection />
                </SectionBoxContainer>
            </div> */}

        </div>
    )
}